import SchemaMarkup from "../Components/SchemaMarkup";

const MedicalWebPageSchema = ({ treatment }) => {
  if (!treatment) return null;

  const url = `https://msayurved.com/treatments/${treatment.slug}/`;

  const schema = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "@id": `${url}#medicalwebpage`,
    "url": url,
    "name": treatment.title,
    "description": treatment.metaDesc,
    "isPartOf": {
      "@id": "https://msayurved.com/#website"
    },
    "about": {
      "@id": `${url}#treatment`
    },
    "mainEntity": {
      "@id": `${url}#treatment`
    },
    "publisher": {
      "@id": "https://msayurved.com/#organization"
    },
    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default MedicalWebPageSchema;